import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Clock, MapPin, X } from "lucide-react";
import "../../../styles/ShopifyGeoActiveFilters.scss";

export type ShopifyGeoActiveFiltersProps = {
  showFilterBar: boolean;
  filterChipText: string;
  filterRegionLabel: string | null;
  resolvedCityDisplayName: string | null;
  heatmapFilterLabel: string | null;
  removeRegionFilter: () => void;
  removeCityFilter: () => void;
  removeTimeFilter: () => void;
  onReset: () => void;
};

const ShopifyGeoActiveFilters: FC<ShopifyGeoActiveFiltersProps> = ({
  showFilterBar,
  filterChipText,
  filterRegionLabel,
  resolvedCityDisplayName,
  heatmapFilterLabel,
  removeRegionFilter,
  removeCityFilter,
  removeTimeFilter,
  onReset,
}) => {
  const { t } = useTranslation();

  return (
    <div className="shopify-geo__toolbar">
      {showFilterBar ? (
        <section
          className="shopify-geo__active-filters"
          aria-label={t("shopifyGeo.crossFilter.sectionAria")}
        >
          <div className="shopify-geo__active-filters-head">
            <span className="shopify-geo__active-filters-title">
              {t("shopifyGeo.crossFilter.sectionTitle")}
            </span>
          </div>
          <div className="shopify-geo__active-filters-row">
            <div
              className="shopify-geo__active-filters-pills"
              title={filterChipText || undefined}
            >
              {filterRegionLabel ? (
                <span className="shopify-geo__filter-pill shopify-geo__filter-pill--region">
                  {filterRegionLabel}
                  <button
                    type="button"
                    className="shopify-geo__filter-pill-remove"
                    onClick={removeRegionFilter}
                    aria-label={`Remove ${filterRegionLabel} filter`}
                  >
                    <X size={10} aria-hidden />
                  </button>
                </span>
              ) : null}
              {resolvedCityDisplayName ? (
                <span className="shopify-geo__filter-pill shopify-geo__filter-pill--city">
                  <MapPin size={12} aria-hidden />
                  {resolvedCityDisplayName}
                  <button
                    type="button"
                    className="shopify-geo__filter-pill-remove"
                    onClick={removeCityFilter}
                    aria-label={`Remove ${resolvedCityDisplayName} filter`}
                  >
                    <X size={10} aria-hidden />
                  </button>
                </span>
              ) : null}
              {heatmapFilterLabel ? (
                <span className="shopify-geo__filter-pill shopify-geo__filter-pill--time">
                  <Clock size={12} aria-hidden />
                  {heatmapFilterLabel}
                  <button
                    type="button"
                    className="shopify-geo__filter-pill-remove"
                    onClick={removeTimeFilter}
                    aria-label={`Remove ${heatmapFilterLabel} filter`}
                  >
                    <X size={10} aria-hidden />
                  </button>
                </span>
              ) : null}
              {!filterChipText ? (
                <span className="shopify-geo__filter-pill shopify-geo__filter-pill--loading">
                  {t("shopifyGeo.crossFilter.applying")}
                </span>
              ) : null}
            </div>
            <button
              type="button"
              className="shopify-geo__active-filters-reset"
              onClick={onReset}
            >
              {t("shopifyGeo.crossFilter.reset")}
            </button>
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default ShopifyGeoActiveFilters;
